<template>
<v-container fluid>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title>作業日報出張</v-card-title>
        <!-- 工事情報 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-text-field label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field label="工事名" v-model="tabData.constructionName" prepend-inner-icon="mdi-message-settings-variant-outline" dense outlined readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-select label="工種" v-model="tabData.constructionType" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.constructionTypeList" item-text="name" item-value="value" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="!workAreaDivision">
              <v-select label="作業項目" v-model="tabData.workItem" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.workItemList" item-text="name" item-value="value" :disabled="tabData.constructionType == null" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 入力フォーム -->
        <v-form ref="tab_form" v-model="tabValid" @submit.prevent>
          <v-container fluid>
            <div>
              <v-toolbar color="accent" dark flat dense><v-toolbar-title>出張情報</v-toolbar-title></v-toolbar>
              <v-row><v-col cols="12"><header>出張情報</header></v-col></v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="tabData.businessTrip" label="出張先" prepend-inner-icon="mdi-bus" dense outlined readonly></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-checkbox v-model="tabData.stay" label="宿泊あり" dense readonly></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <header>移動方法</header>
                  <v-radio-group v-model="tabData.move" row readonly>
                    <v-radio :label="moveWay.nothing.name" :value="moveWay.nothing.id"></v-radio>
                    <v-radio :label="moveWay.airplane.name" :value="moveWay.airplane.id"></v-radio>
                    <v-radio :label="moveWay.jr.name" :value="moveWay.jr.id"></v-radio>
                    <v-radio :label="moveWay.car.name" :value="moveWay.car.id"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <header>高速道路(ETC)</header>
                  <v-checkbox v-model="tabData.etc" label="使用あり" dense readonly></v-checkbox>
                </v-col>
              </v-row>
              <v-row><v-col cols="12"><header>備考</header></v-col></v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea v-model="tabData.remark" label="備考" rows="5" prepend-inner-icon="mdi-comment-processing-outline" outlined readonly></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-form>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="{ name: returnViewName, params: { worker_date: prmWorkerDate, user_id: prmUserId } }">戻る</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import WorkerDailyReportExpenseBulkApi from "@/api/worker-daily-report-expense-bulk-api";
export default {
  name: "WorkerDailyReportBusinessTripInfo",
  data: () => ({
    loading: false,
    returnViewName: "",
    // 画面引数
    prmRecordId: 0,
    prmUserId: null,
    prmWorkerDate: "",
    prmReferrer: "",
    // ------------------------
    // 共通
    // ------------------------
    // 作業日
    constructionDate: "",
    // 作業項目可否
    workAreaDivision: false,
    // 格納用
    tabData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: null,
      workerBreakMinuteTime: null,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: null,
      overBreakMinuteTime: null,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },
    // バリデート
    tabValid: true,

    // ------------------------
    // 出張情報
    // ------------------------
    // 移動方法
    moveWay: {
      nothing: {name: "なし", id: 0},
      airplane: {name: "飛行機", id: 1},
      jr: {name: "JR", id: 2},
      car: {name: "社用車/自家用車", id: 3}
    }
  }),
  created() {
    this.initialize();
  },
  methods: {
    // ------------------------
    // 初期化処理
    // ------------------------
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmRecordId = this.$route.params.id;
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      this.prmReferrer = this.$route.params.referrer;
      this.constructionDate = this.prmWorkerDate;
      // パンくずリストの設定
      let breadcrumbs = [];
      if (this.prmReferrer == 'info') {
        // 作業日報閲覧画面からの遷移
        this.returnViewName = 'WorkerDailyReportInfo';
        const toView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
          { text: "作業日報", disabled: false, href: null, to: toView },
          { text: "作業日報出張", disabled: true }
        ];
      }
      if (this.prmReferrer == 'approval') {
        // 作業日報確認(工事日報)からの遷移
        this.returnViewName = 'WorkerDailyReportApproval';
        const toView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "工事日報一覧", disabled: false, href: "/report/daily/construction" },
          { text: "作業日報確認", disabled: false, href: "/report/daily/worker/comform" },
          { text: "作業日報", disabled: false, href: null, to: toView },
          { text: "作業日報出張", disabled: true }
        ];
      }
      if (breadcrumbs) {
        this.$route.meta.breadcrumbs = breadcrumbs;
        this.$emit('updatebc');
      }
      // 作業日報を取得
      this.workerDailyReportExpenseBulkApi = new WorkerDailyReportExpenseBulkApi();
      const promise = this.workerDailyReportExpenseBulkApi.info(this.prmRecordId);
      promise.then((response) => {
        // 日報情報をセット
        this.tabData = response.data.body.worker_daily_report_info.report;
        this.workAreaDivision = this.tabData.workArea;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId } });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },

    // ------------------------
    // その他処理
    // ------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    }
  }
}
</script>
